module.exports = __webpack_public_path__ + "img/rocket.427de72f.gif";